import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  signal,
} from '@angular/core';
import { ModalBaseDirective } from '$core/base/_modal.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  standalone: true,
  selector: 'app-user-agreement-updating-modal',
  imports: [FormsModule, TranslateModule, FontAwesomeModule],
  templateUrl: './user-agreement-updating-modal.component.html',
  styleUrls: ['./user-agreement-updating-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserAgreementUpdatingModalComponent extends ModalBaseDirective {
  private readonly router = inject(Router);

  /**
   * Whether the user has agreed to the user agreement update.
   */
  protected isAgreedToUserAgreementUpdate = signal(false);

  /**
   * Whether the user agreement update is disabled.
   */
  protected isUserAgreementUpdateDisabled = computed(
    () => !this.isAgreedToUserAgreementUpdate()
  );

  protected readonly icon = faInfoCircle;

  constructor(
    protected readonly modalRef: BsModalRef,
    protected readonly modalService: BsModalService,
    protected readonly translates: TranslateService
  ) {
    super(modalRef, modalService, translates);
  }

  protected navigateToUserAgreement(event: Event): void {
    event.stopPropagation();
    event.preventDefault();

    const urlTree = this.router.createUrlTree([
      '/articles/portal-public-offer',
    ]);
    const url = this.router.serializeUrl(urlTree);

    window.open(url, '_blank');
  }

  protected confirm(): void {
    this.hide('confirm');
  }

  /**
   * The agreement is mandatory: the modal may only be closed by confirming it.
   */
  public override onPopState(): void {}
}
